export const ERROR_CODES = {
  WORKFLOW_REQUESTS: {
    REQUEST_RECALLED: 'workflowrequests:request_recalled',
    UNAUTHORIZED: 'workflowrequests:unauthorized',
    REQUEST_NOT_FOUND: 'workflowrequests:not_found',
  },
};
